export default (state, action) => {
  const { messageId } = action.payload
  return {
    ...state,
    flashMessages: [
      ...state.flashMessages.filter(message => message.id !== messageId),
    ],
  }
}
